import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export interface SchoolData {
    school: string;
    schoolYear: string;
}

export function schoolConfig(): PageConfig[] {
    return [
        {
            name: "school",
            title: "School - Te Kura",
            questions: [
                {
                    type: "text",
                    name: "school",
                    title: "School Name",
                    placeHolder: "Ingoa o te Kura",
                    isRequired: true,
                },
                {
                    type: "text",
                    name: "schoolYear",
                    title: "School Year",
                    placeHolder: "Tau Kura",
                    startWithNewLine: false,
                    isRequired: true,
                },
            ],
        },
    ];
}
